//Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start  
import { memo } from "react";
import { useSelector } from "react-redux";
import { BzChip } from "../../components";
import { EXCHANGE_NAME_LIVEPULSE, SCRIP_INSTRUMENTS } from "../../utils/global_variables";
import OrderDisplayDescription from "./OrderDisplayDescription";

const OrderSymbolColumn = (props) => {
    const { objRowData,

    } = props;
    const holdingsScrips = useSelector(state => state.holdings?.holdingsScrips);
    return (
        <div >
            {/* {objRowData.dontMiss?.length > 0 && <div className='normal-scrip dontmiss-scrip'></div>} */}
            <div className='d-flex align-items-center'>
                {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start */}
                <span className='font-medium font-enlarge color-text ms-3 text-uppercase'>{objRowData?.title || objRowData?.symbol}</span> {/* Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings */}
                {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End */}
                <span className='chips-wrap px-2'>
                    <BzChip className='exchange-chip text-capitalize'>{objRowData?.exchangeSegment ? EXCHANGE_NAME_LIVEPULSE[objRowData?.exchangeSegment] : EXCHANGE_NAME_LIVEPULSE[objRowData?.exchange]}</BzChip> {/**Ajitesh 26-07-2024 Adds condition to show NSECDS and BSECDS in order book for currency devs */}
                </span>
                {/* Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start */}
                <OrderDisplayDescription objRowData={objRowData} />
                {/* Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End */}
                {/*    DontMiss Logic commented as BA (Mithun) suggested dontMiss will not show for orders */}

                {/* {objRowData?.dontMiss?.length > 0 && <span className='icon-16 icon-dontmiss icon-yellow ms-2'></span>} */}
                {/* Vaibhav Singh: Holding icon removed from order book: Start */}
                {holdingsScrips?.length > 0 && holdingsScrips?.some(element => element?.TOTALFREEQUANTITY !== "0" && element?.ISIN === objRowData?.sISINCode && objRowData?.instrument === SCRIP_INSTRUMENTS.EQUITIES) && < span className='icon-16 icon-portfolio icon-dark ms-2'></span>}
                {/* Deepti B : BT-106965 :Breeze - Order Book - order cart name and order cart icon  ---start */}
                {/* BT-106965 : OrderCart : ManasaB:26-09-2024 : Taken code changes from Sumit after discussion with Ashwini - Start */}
                <div className='chips-wrap px-2'>
                    {
                        objRowData?.ordercartName && (
                            <>
                                <BzChip className='chips primary-chip text-capitalize'>
                                    <div className='icon-12 icon-cart icon-primary float-start me-1 m-t-1'></div>
                                    <span className='float-start'>{objRowData?.ordercartName}</span>
                                </BzChip>
                            </>
                        )
                    }
                </div>
                {/* BT-106965 : OrderCart : ManasaB:26-09-2024 : Taken code changes from Sumit after discussion with Ashwini - End */}
                {/* Deepti B : BT-106965 :Breeze - Order Book - order cart name and order cart icon  ---end */}
            </div >
        </div >
    );
};
export default memo(OrderSymbolColumn);
//Azeem K : 16-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End  
